class LayoutManager {
  private static instance: LayoutManager | null = null;
  private isLayoutFetched: boolean = false;

  private constructor() {
    // can add anything here according to future requirements
  }

  public static getInstance(): LayoutManager {
    if (!LayoutManager.instance) {
      LayoutManager.instance = new LayoutManager();
    }

    return LayoutManager.instance;
  }

  public async refreshLayout(requests: any[]): Promise<void> {
    try {
      await Promise.all(requests.map((request) => request()));

      this.isLayoutFetched = true;
    } catch (error) {
      console.error('Error refreshing product layout:', error);
      throw error;
    }
  }

  public isProductLayoutPresent(): boolean {
    return this.isLayoutFetched;
  }
}

const instance = LayoutManager.getInstance();

export default instance;
